import { SVGProps } from 'react';

const DecimalsArrowLeft = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="m13 15-3 3 3 3m-3-3h10M3 11h.01M8.5 3A2.5 2.5 0 0 1 11 5.5v3a2.5 2.5 0 0 1-5 0v-3A2.5 2.5 0 0 1 8.5 3"
    />
  </svg>
);
export default DecimalsArrowLeft;
